import React from 'react';
import PropTypes from 'prop-types';
import { Parser } from 'html-to-react';

function Template(props) {
  const { template } = props;
  const htmlToReactParser = new Parser();
  const reactElement = htmlToReactParser.parse(template);
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{reactElement}</>;
}

Template.propTypes = {
  template: PropTypes.string.isRequired,
};

export default Template;
